import React, { useEffect, useState } from "react";
import { Search } from "react-feather";
import styled from "styled-components";
import { useSearchBar } from "./context/SearchBarContext";

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 5px;
  padding: 8px 12px;
  width: 100%;
  max-width: 500px;
`;

const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: #777;
  background: transparent;
  &::placeholder {
    color: #ccc;
  }
`;

const SearchIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  margin-left: 8px;
  cursor: pointer;
`;

const SearchBar = () => {
  const { searchBarVisible, setSearchBarText, searchBarText } = useSearchBar();
  const [text, setText] = useState(searchBarText);

  useEffect(() => {
    setText(searchBarText);
  }, [searchBarText]);

  const handleQueryChange = (event) => {
    setText(event.target.value);
  };

  const handleQueryBlur = (event) => {
    if (searchBarText !== event.target.value) {
      setSearchBarText(event.target.value);
    }
  };

  const handleQueryKeyDown = (event) => {
    if (event.key === "Enter" && searchBarText !== event.target.value) {
      setSearchBarText(event.target.value);
    }
  };

  return (
    <>
      {searchBarVisible && (
        <SearchContainer>
          <SearchInput
            type="search"
            placeholder="Buscar"
            onBlur={handleQueryBlur}
            onChange={handleQueryChange}
            onKeyDown={handleQueryKeyDown}
            name="query"
            id="query"
            value={text}
          />
          <SearchIcon>
            <Search size="18" color="#f0292a" />
          </SearchIcon>
        </SearchContainer>
      )}
    </>
  );
};

export default SearchBar;
